import React from 'react'
import PageRenderer from '../page-renderer/index'
import PageSizeControl from '../page-size-control'
import TotalRenderer from '../total-renderer'
import { Spinner } from 'reactstrap'
import { withGridContext } from '../providers'
import { ContextType } from '../types/advanced-grid.types'

/**
 * Component to render the table footer
 * @author Alejandro Quiroz <alejandro.devop@gmail.com>
 * @version 1.0.0
 * @returns
 */
const TableFooter: React.FC<ContextType> = ({ loading }) => {
    return (
        <div className="flex flex-1 items-center">
            <div className="mr-24 flex items-center">
                {loading && (
                    <div className="width-30  flex justify-center">
                        <Spinner size="sm" color="primary" />
                    </div>
                )}
                <TotalRenderer />
            </div>
            <div className="flex flex-auto items-center justify-end">
                <div className="mr-2 flex flex-row items-center w-40 justify-right">
                    <span className="mr-2 text-xs">Per page</span>
                    <div>
                        <PageSizeControl />
                    </div>
                </div>
                <PageRenderer />
            </div>
        </div>
    )
}

export default withGridContext(TableFooter)
